var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panel-hdr bg-primary-500 bg-success-gradient" },
    [
      _c("h2", [
        _vm._m(0),
        _vm._v("\n        " + _vm._s(this.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-toolbar" }, [
        _c("button", {
          staticClass: "btn btn-panel waves-effect waves-themed",
          attrs: {
            "data-action": "panel-fullscreen",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Fullscreen",
          },
        }),
        _vm._v(" "),
        _vm.button_plus
          ? _c(
              "button",
              {
                staticClass:
                  "btn btn-icon btn-sm btn-danger mr-1 shadow-0 waves-effect waves-themed mr-2 ml-2",
                on: { click: _vm.button_action_emit },
              },
              [_c("i", { staticClass: "fal fa-plus" })]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon-stack fs-xxl mr-2" }, [
      _c("i", {
        staticClass: "base base-7 icon-stack-3x opacity-100 color-primary-500",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "base base-7 icon-stack-2x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "fal fa-cog icon-stack-1x opacity-100 color-white fa-spin",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }